<script lang="ts">
	export let minHeight = 0;
</script>

<div class="preview-box" style={`min-height: ${minHeight}px;`}>
	<span class="preview-box-overlay" />
	<div class="d-flex justify-content-center">
		<slot />
	</div>
</div>

<style>
	.preview-box {
		position: relative;
		background-image: url('/images/loginBackground.png');
		border-radius: var(--radius-big);
		padding: 24px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		overflow: hidden;
	}

	.preview-box-overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: var(--background-image-overlay);
	}
</style>
